import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { scheduleDays } from "@/mocks/schedule";

export default function Schedule() {
  const [activeDay, setActiveDay] = useState(scheduleDays[0].key);
  const current = scheduleDays.find((d) => d.key === activeDay) ?? scheduleDays[0];

  return (
    <section id="schedule" className="w-full px-4 py-16 md:px-8 md:py-24">
      <SectionHeading
        eyebrow="新番放送日历 · 番剧表"
        title="本周更新一览，按天查看"
        description="按周一至周日整理当季作品的更新时间，帮你把追番安排进固定的夜晚，避免漏看进度。"
      />

      <div className="mt-8 overflow-hidden rounded-lg border border-background-200 bg-background-50">
        <div className="no-scrollbar flex gap-1 overflow-x-auto border-b border-background-200 bg-background-100/70 p-2">
          {scheduleDays.map((day) => {
            const active = day.key === activeDay;
            return (
              <button
                key={day.key}
                type="button"
                onClick={() => setActiveDay(day.key)}
                className={`flex shrink-0 flex-col items-center gap-1 whitespace-nowrap rounded-md px-4 py-2 text-sm transition-colors ${
                  active
                    ? "bg-primary-500 text-background-50"
                    : "text-foreground-600 hover:bg-background-200/70 hover:text-foreground-900"
                }`}
              >
                <span>{day.label}</span>
                <span
                  className={`text-[11px] ${active ? "text-background-50/80" : "text-foreground-400"}`}
                >
                  {day.shows.length} 部更新
                </span>
              </button>
            );
          })}
        </div>

        <ul className="divide-y divide-background-200">
          {current.shows.map((show) => (
            <li
              key={`${current.key}-${show.time}-${show.title}`}
              className="flex flex-col gap-3 px-4 py-4 transition-colors hover:bg-background-100/60 sm:flex-row sm:items-center sm:gap-5 md:px-6"
            >
              <span className="flex w-16 shrink-0 items-center gap-1.5 text-sm text-primary-700">
                <i className="ri-time-line" />
                {show.time}
              </span>
              <div className="min-w-0 flex-1">
                <p className="truncate text-sm text-foreground-950">{show.title}</p>
                <p className="mt-0.5 text-xs text-foreground-500">{show.ep}</p>
              </div>
              <span className="w-fit shrink-0 rounded-full bg-accent-100 px-3 py-1 text-[11px] text-accent-800">
                {show.tag}
              </span>
            </li>
          ))}
        </ul>

        <div className="flex flex-wrap items-center gap-x-6 gap-y-2 border-t border-background-200 bg-background-100/60 px-4 py-3 text-xs text-foreground-500 md:px-6">
          <span className="flex items-center gap-1.5">
            <i className="ri-information-line" />
            时间按常见放送习惯整理，实际以官方公布为准
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-refresh-line" />
            每周更新当日排期
          </span>
        </div>
      </div>
    </section>
  );
}